"use client"

import { AlignHorizontalDistributeStart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignHorizontalDistributeStartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignHorizontalDistributeStartIcon = component(Icon)({
  as: AlignHorizontalDistributeStart,
})
